export default "__VITE_ASSET__CpzM2Q4G__"